export default __webpack_public_path__ + "static/media/typejs.c4105801.png";